import { api } from "./auth";

export async function submitLead(payload) {
    const res = await api.post("/leads", payload);
    return res.data;
}

export async function submitOrganicLead(payload) {
    const res = await api.post("/leads/organic", payload);
    return res.data;
}

export async function fetchTestimonials() {
    const res = await api.get("/testimonials", { params: { active: true } });
    return res.data;
}

export async function fetchFaq() {
    const res = await api.get("/faq", { params: { active: true } });
    return res.data;
}

export async function fetchSettings() {
    const res = await api.get("/settings/public");
    return res.data;
}

/* Jarvis API */

export async function jarvisCreateSession() {
    const res = await api.post("/jarvis/session", {});
    return res.data;
}

export async function jarvisSendMessage(session_id, message) {
    const res = await api.post("/jarvis/chat", { session_id, message });
    return res.data;
}

export async function jarvisGetSession(session_id) {
    const res = await api.get(`/jarvis/session/${session_id}`);
    return res.data;
}

/* Phase 8 — Jarvis chat history (authenticated) */

export async function jarvisListSessions() {
    const res = await api.get("/jarvis/sessions");
    return res.data;
}

export async function jarvisGetMySession(session_id) {
    const res = await api.get(`/jarvis/sessions/${session_id}`);
    return res.data;
}

export async function jarvisContinueSession(session_id) {
    const res = await api.post(`/jarvis/sessions/${session_id}/continue`);
    return res.data;
}

export async function jarvisSummarize(session_id) {
    const res = await api.post("/jarvis/summarize", { session_id });
    return res.data;
}

export async function jarvisFinalize(session_id) {
    const res = await api.post("/jarvis/finalize", { session_id });
    return res.data;
}

/* Phase 6 — Public booking + recruiting */

export async function submitBooking(payload) {
    const res = await api.post("/booking", payload);
    return res.data;
}

export async function uploadResume(file) {
    const fd = new FormData();
    fd.append("file", file);
    const res = await api.post("/recruiting/resume", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
}

export async function submitRecruiting(payload) {
    const res = await api.post("/recruiting", payload);
    return res.data;
}
